export const serverFieldErrors: { [key: string]: string } = {
  'This field must be unique.': 'field.error.email.alreadyExsist',
  'This password is too common.': 'field.error.password.toCommon',
  'This password is entirely numeric.': 'field.error.password.entirelyNumeric',
  'This email is already used.': 'fields.error.email.alreadyTaken',
};

interface ErrType {
  [key: string]: Array<string> | string;
}

interface TranslateFieldErrorsProps {
  t: any;
  err: ErrType;
}

export const translateFieldErrors = ({ t, err }: TranslateFieldErrorsProps) => {
  const translatedErrors: any = {};

  Object.keys(err).forEach((field: any) => {
    translatedErrors[field] = [];

    const isFieldHasMulitpleErr = err[field][0].includes('[');

    if (isFieldHasMulitpleErr) {
      const arrayOfMsgDirty = err[field][0].replace(/\[|\]/g, '').split("', '");

      arrayOfMsgDirty.forEach((elem: string) => {
        const cleanMsg = elem.replace(/'/g, '');
        const serverMsg = serverFieldErrors[cleanMsg];

        translatedErrors[field].push(
          t(serverMsg || 'mising.translation', cleanMsg)
        );
      });
    } else {
      const message = err[field][0];

      const serverMsg = serverFieldErrors[message];
      const translated = t(serverMsg || 'missing.translation', message);

      translatedErrors[field].push(translated);
    }
  });
  return translatedErrors;
};
